import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';

import Burger from 'components/atoms/Burger';
import MobileMenu from 'components/molecules/MobileMenu';

import LogoSvg from 'assets/images/ristora-logo.svg';

import { Wrapper, Image } from './styled';
import RouterHelper from '../../../services/RouterHelper';
import routeCodes from '../../../common/constants/route-codes';

const AdminHeader = () => {
  const [openMenu, setMenuOpen] = useState(false);

  const onChange = useCallback(() => {
    setMenuOpen((bool) => !bool);
  }, []);

  return (
    <Wrapper>
      <Link
        to={RouterHelper.getRedirectRouteWithRestaurantId(routeCodes.home)}
        style={{ marginTop: 5 }}
      >
        <Image src={LogoSvg} />
      </Link>
      <Burger onChange={onChange} open={openMenu} />
      <MobileMenu open={openMenu} />
    </Wrapper>
  );
};

export default AdminHeader;
